<template>
  <div class="iframe-container">
    <iframe
      :src="'https://gala.talentprint.com/users/manage_raters/'+autoLoginToken"
      class="w-full h-full border-0"
    >
    </iframe>
  </div>
</template>

<script>
  export default {
    name: "Main",
    created() {
      this.$store.commit("SET_PAGE_TYPE", "alex-connect");
      this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "#F7F7F7");
      this.$store
        .dispatch("boards/fetchUserBoardData",this.$store.state.auth.user._id ).then(res=>{

      }) .catch((err) => {
        throw err;
      })
    },
    computed: {
      autoLoginToken() {
        return this.$store.state.boards.userBoardData.youlabToken;
      },
    }
  };
</script>
<style scoped>
  .iframe-container {
    height: 1005px;
    margin-top: 6rem;
  }
</style>
